import { StyledDot, StyledPageLoader } from '@/components/PageLoader/styles';

interface PageLoaderProps {
  animateOut?: boolean;
  animateOutTime?: number;
}

export function PageLoader({ animateOut = false, animateOutTime = 500 }: PageLoaderProps) {
  return (
    <StyledPageLoader $phaseOut={animateOut} $phaseOutTime={animateOutTime}>
      {/* <img src="/white_standard.png" alt="logo" /> */}
      <img src="/black_standard.png" alt="logo" />
      <h2>
        Uw reis ophalen
        <StyledDot>.</StyledDot>
        <StyledDot>.</StyledDot>
        <StyledDot>.</StyledDot>
      </h2>
    </StyledPageLoader>
  );
}
